var center = canvas.getCenter();
var timestamp = Math.floor((new Date()).getTime() / 1000); //get UTC time
var interval = 1000;
var totalProgress = 0;

//update real-time progress
function showProgress(perc) {
    if(perc > totalProgress) {
        totalProgress = perc;
        console.log('progress: '+perc);
        $('#comp-perc').html(perc+'%');
        $('.ko-progress-circle').attr('data-progress', perc);
    }
}
                
//add variants to cart
function moveAlong(){
    console.log('adding items to cart...');
    if (variants.length) {
        var tempId= variants.shift();
        var tempQty = quantity.shift();
        var tempSize = sizes.shift();
        if(mtCat == 'dtgcrewtee' || mtCat == 'dtgwomencrewtee' || mtCat == 'dtgkidscrewtee') {
            var properties = {
              '_FrontPrintReadyFile': 'https://modthread.blob.core.windows.net/generated/'+timestamp+'_m1.jpg',
              '_BackPrintReadyFile': 'https://modthread.blob.core.windows.net/generated/'+timestamp+'_m0.jpg',
              '_FrontImg': printReadyFiles.final_front_image,
              '_BackImg': printReadyFiles.final_back_image
            };
        } else if(mtCat == 'leggings' || mtCat == 'blanket' || mtCat == 'tapstry' || mtCat == 'towel') {
            var properties = {
              '_printReadyFile': 'https://modthread.blob.core.windows.net/generated/'+timestamp+'_'+tempSize+'.jpg',
              '_FrontImg': printReadyFiles.final_front_image
            };
        } else {
            var properties = {
              '_printReadyFile': 'https://modthread.blob.core.windows.net/generated/'+timestamp+'_'+tempSize+'.jpg',
              '_FrontImg': printReadyFiles.final_front_image,
              '_BackImg': printReadyFiles.final_back_image
            };
        }
        var params = { 
            quantity: tempQty,
            id: tempId,
            properties: properties,
        };
        console.log(params);
        jQuery.post('/cart/add.js', params)  
        .done(function() {
            moveAlong();
        })
        .fail(function() {
            moveAlong();
        });
    } else {
        console.log('redirecting...');
        window.location = "/cart";
    }  
};

//send parts to server
function sendParts(){
    console.log('sending parts...')
    var final_front =  $('#final_front_img').val();
    var final_front_image = b64toBlob(final_front, 'image/png');
    var final_back =  $('#final_back_img').val();
    var sleeve_pattern =  $('#sleeve_pattern').val();
    var final_back_image = b64toBlob(final_back, 'image/png');
    printData.append('final_front_image',final_front_image, 'final_front_image.png');
    printData.append('final_back_image',final_back_image, 'final_back_image.png');
    printData.append('sleeve_pattern',sleeve_pattern );
    printData.append('timestamp', timestamp);
    printData.append('size', sizes);
    printData.append('type', mtType);
    printData.append('prod_cat', mtCat);
    
    console.log(printData);
//    return false;
    if(mtCat == 'leggings' || mtCat == 'blanket' || mtCat == 'tapstry' || mtCat == 'towel') {
        printData.delete('final_back_image');
    }

    $.ajax({
        xhr: function() {
            var xhr = new window.XMLHttpRequest();

            xhr.upload.addEventListener("progress", function(evt) {
              if (evt.lengthComputable) {
                var percentComplete = evt.loaded / evt.total;
                percentComplete = parseInt(percentComplete * 100);
                showProgress(percentComplete);
                if (percentComplete === 100) {
                    console.log("uploaded all the files");
                }
              }
            }, false);

            return xhr;
        },
        type: 'POST',
        url: 'https://modthread.co/azure_blob/web/parts.php',
        data: printData,
        processData: false,
        contentType: false,
        success: function (response) {
            console.log('response from the server...');
            console.log(response);
            printReadyFiles = response;
            if(!printReadyFiles.final_back_image && mtCat !== 'leggings') {
                printReadyFiles.final_back_image = $('.flex-control-nav li:last-child').find('img').attr('src');
            }
            moveAlong();
        },
        error: function (response) {                
            console.log('opps! something went wrong...');        
            $('body').css('position', 'initial');
            $('body').css('overflow', 'visible'); 
            $('.last-loader').css('display', 'none');
            $('#comp-perc').html('0%');
            $('.ko-progress-circle').attr('data-progress', 0);
            totalProgress = 0;
            alert('Something went wrong. Please try again.');
            return false;
        },
        timeout: 1000000
    });
}

//get collar print ready
function getCollarPrintReady(sizes) {
    canvas.clear();     
    //get print ready images
    canvas.setBackgroundImage($('#sleeve-pattern-img').val(), function(){ 
        $.each(sizes, function(index, size) {
            setTimeout(function () {     
                collarOverlay = printCollarOverlay[size]; 
                console.log('collar ' + size);
                fabric.Image.fromURL(collarOverlay, function(overlayImg) {
                    overlayImg.scaleToWidth(canvas.getWidth());
                    overlayImg.set({
                        'id': 'overlay',
                        top: center.top,
                        left: center.left,
                        originX: 'center',
                        originY: 'center',
                        crossOrigin: 'anonymous'
                    });
                    canvas.setOverlayImage(overlayImg, canvas.renderAll.bind(canvas));

                    try {                          
                        //generate print ready for back
                        var img = canvas.toDataURL({
                            format: 'jpeg',
                            quality: 0.9,
                            multiplier: 5.25,
                            left: 0,
                            top: parseFloat((canvas.height - (overlayImg.height*overlayImg.scaleY))/2),
                            width: canvas.width,
                            height: parseFloat(overlayImg.height*overlayImg.scaleY)
                        });
                        var blob = img.replace(/^data:image\/(png|jpeg);base64,/, "");
                        collar_part = b64toBlob(blob, 'image/jpeg');
                        printData.append('collar_'+ size, collar_part, 'collar_'+ size +'.jpeg');
                    } catch (e) {
                        bugsnagClient.notify(new Error(e));
                        console.log(e);
                    } 

                    showProgress(index);
                    
                    if((index+1) == sizes.length) { 
                        console.log("last collar");
                        setTimeout(function() { getSleevePrintReady(sizes); }, interval);
                    }
                });
            }, index * interval);
        });
    }, {
        backgroundImageStretch: true,
        id: 'bg-image',
        scaleY: 0.333333,
        scaleX: 0.333333,
        crossOrigin: 'anonymous'
    });
}

//get sleeve print ready
function getSleevePrintReady(sizes) {
    var parts = {};
    var len = 0;
    var i = 0;
    
    //make simple array
    $.each(sizes, function(index, size) { 
        var sleeveOverlay = printSleeveOverlay[size];
        if(!$.isArray(sleeveOverlay)) { 
            parts[size] = sleeveOverlay;
        } else { 
            $.each(sleeveOverlay, function(i, v) {
                parts[size+'_'+i] = v;
            });
        }
    });
    //get print ready
    $.each(parts, function(index, part) {
        setTimeout(function () {  
            //set new overlay for back 
            console.log('sleeve '+ index);
            fabric.Image.fromURL(part, function(overlayImg) {
                if(overlayImg.width > overlayImg.height) {
                    overlayImg.scaleToWidth(canvas.getWidth());
                } else {
                    overlayImg.scaleToHeight(canvas.getHeight());
                }
                overlayImg.set({
                    'id': 'overlay',
                    top: center.top,
                    left: center.left,
                    originX: 'center',
                    originY: 'center',
                    crossOrigin: 'anonymous'
                });
                canvas.setOverlayImage(overlayImg, canvas.renderAll.bind(canvas));

                try {  
                    //generate print ready for back
                    var img = canvas.toDataURL({
                        format: 'jpeg',
                        quality: 0.9,
                        multiplier: 5.0,
                        left: parseFloat((canvas.width - (overlayImg.width*overlayImg.scaleX))/2),
                        top: parseFloat((canvas.height - (overlayImg.height*overlayImg.scaleY))/2),
                        width: parseFloat(overlayImg.width*overlayImg.scaleX),
                        height: parseFloat(overlayImg.height*overlayImg.scaleY)
                    });   

                    var blob = img.replace(/^data:image\/(png|jpeg);base64,/, "");
                    sleeve_part = b64toBlob(blob, 'image/jpeg');
                    printData.append('sleeve_'+ index, sleeve_part, 'sleeve_'+ index +'.jpeg');    
                } catch (e) {
                    bugsnagClient.notify(new Error(e));
                    console.log(e);
                } 
                len += 1;
                if(len == Object.keys(parts).length) {
                    console.log("last sleeve");
                    setTimeout(function() { getBackPrintReady(sizes); }, (interval*2));
                }
            });
        }, (interval*i));
        i++;
    });
}

//get back print ready
function getBackPrintReady(sizes) {    
    var m_obj = false;
    //not visited back ever
    if (typeof back == 'undefined') {
        var serialized = JSON.parse(front);
        for (var i = 0, len = serialized.objects.length; i < len; i++) {
            if (serialized.objects[i] && serialized.objects[i].id !== 'overlay') {
                serialized.objects.splice(i, 1);
            }
        }
    } else { //hide sleeves
        var serialized = JSON.parse(back);
        for (var i = 0, len = serialized.objects.length; i < len; i++) {
            if (serialized.objects[i] && serialized.objects[i].id === 'mask') {
                m_obj = parseInt(i + 1);
                serialized.objects[i].opacity = 0;
            }
            if (serialized.objects[i] && serialized.objects[i].id === 'default-pattern') { 
                var str = serialized.objects[i].src;
                serialized.objects[i].src = str.replace("_742x700", "");
            }
        }
    }
    serialized = JSON.stringify(serialized);

    canvas.clear();
    //get print ready images
    canvas.loadFromJSON(JSON.parse(serialized), function() {
        $.each(sizes, function(index, size) {
            setTimeout(function () {  
                backOverlay =  printBackOverlay[size];
                console.log('back '+ size);
                //set new overlay for back
                fabric.Image.fromURL(backOverlay, function(overlayImg) {
                    overlayImg.scaleToWidth(canvas.getWidth());
                    overlayImg.scaleToHeight(canvas.getHeight());
                    overlayImg.set({
                        'id': 'overlay',
                        top: center.top,
                        left: center.left,
                        originX: 'center',
                        originY: 'center',
                        crossOrigin: 'anonymous'
                    });
                    canvas.setOverlayImage(overlayImg, canvas.renderAll.bind(canvas));

                    try {                         
                        var img = canvas.toDataURL({
                            format: 'jpeg',//png
                            quality: 0.9,
                            multiplier: 8.0,
                            left: parseFloat((canvas.width - (overlayImg.width*overlayImg.scaleX))/2),
                            top: 0,
                            width: parseFloat(overlayImg.width*overlayImg.scaleX),
                            height: canvas.height
                        });      

                        var blob = img.replace(/^data:image\/(png|jpeg);base64,/, "");
                        back_part = b64toBlob(blob, 'image/jpeg');
                        printData.append('back_'+ size, back_part, 'back_'+ size +'.jpeg');     
                    } catch (e) {
                        bugsnagClient.notify(new Error(e));
                        console.log(e);
                    } 

                    if((index+1) == sizes.length) {
                        console.log("last back");
                        setTimeout(function() { getFrontPrintReady(sizes); }, (interval*2));
                    }
                });
                showProgress(2*index);
            }, (index * interval));
        });
    });
}

//get front print ready
function getFrontPrintReady(sizes) { 
    var m_obj = false;
    var serialized = JSON.parse(front);
    for (var i = 0, len = serialized.objects.length; i < len; i++) {
        if (serialized.objects[i] && serialized.objects[i].id === 'mask') {
            m_obj = parseInt(i + 1);
            serialized.objects[i].opacity = 0;
        }
        if (serialized.objects[i] && serialized.objects[i].id === 'default-pattern') { 
           var str = serialized.objects[i].src;
           serialized.objects[i].src = str.replace("_742x700", "");
        }
    }
    serialized = JSON.stringify(serialized);

    canvas.clear();
    canvas.loadFromJSON(JSON.parse(serialized), function() {
        //get print ready images
        $.each(sizes, function(index, size) {
            setTimeout(function () {  
                frontOverlay = printFrontOverlay[size];
                console.log('front '+ size);
                //set new overlay for front
                fabric.Image.fromURL(frontOverlay, function(overlayImg) {
                    overlayImg.scaleToWidth(canvas.getWidth());
                    overlayImg.scaleToHeight(canvas.getHeight());
                    overlayImg.set({
                        'id': 'overlay',
                        top: center.top,
                        left: center.left,
                        originX: 'center',
                        originY: 'center',
                        crossOrigin: 'anonymous'
                    });
                    canvas.setOverlayImage(overlayImg, canvas.renderAll.bind(canvas));

                    try { 
                        //generate print ready for front
                        var img = canvas.toDataURL({
                            format: 'jpeg',//png
                            quality: 0.9,
                            multiplier: 8.0,
                            left: parseFloat((canvas.width - (overlayImg.width*overlayImg.scaleX))/2),
                            top: 0,
                            width: parseFloat(overlayImg.width*overlayImg.scaleX),
                            height: canvas.height
                        });

                        var blob = img.replace(/^data:image\/(png|jpeg);base64,/, "");
                        front_part = b64toBlob(blob, 'image/jpeg');
                        printData.append('front_'+ size, front_part, 'front_'+ size +'.jpeg');     
                    } catch (e) {
                        bugsnagClient.notify(new Error(e));
                        console.log(e);
                    } 

                    showProgress(parseInt(sizes.length+index));

                    if((index+1) == sizes.length) {
                        console.log("last front");
                        setOverlay(origFrontOverlay);
                        setTimeout(function() { sendParts(); }, (interval*2));
                    }
                });
                showProgress(3*index);
            }, (index * interval));
        });
    });
}

//get DTG back print ready
function getDtgBackPrintReady(frontCord, backCord) { 
    canvas.clear();
    if(typeof back !== 'undefined') {
        canvas.loadFromJSON(JSON.parse(back), function() {
            canvas.renderAll().calcOffset();
            var preview = canvas.toDataURL({format: 'jpeg'});
        });
    } else {
        setOverlay(origBackOverlay);
    }    
    
    setTimeout(function() {
        canvas.overlayImage.visible = false;

        try { 
            //generate print ready for back
            var img = canvas.toDataURL({
                format: 'jpeg',
                quality: 0.9,
                multiplier: 15,
                left: backCord.l,
                top: backCord.t,
                width: backCord.w,
                height: backCord.h
            });
            
            var blob = img.replace(/^data:image\/(png|jpeg);base64,/, "");
            back_part = b64toBlob(blob, 'image/jpeg');
            printData.append('back_m', back_part, 'back_m.jpeg');
        } catch (e) {
            bugsnagClient.notify(new Error(e));
            console.log(e);
        } 

        showProgress(sizes.length);
        console.log("back");
        setTimeout(function() { getDtgFrontPrintReady(frontCord); }, 500);
    }, (interval*3));
}

//get DTG front print ready
function getDtgFrontPrintReady(frontCord) {
    canvas.loadFromJSON(JSON.parse(front), function() {
        canvas.overlayImage.visible = false;
        canvas.renderAll().calcOffset();
        setTimeout(function() {
            try {  
                //generate print ready for back
                var img = canvas.toDataURL({
                    format: 'jpeg',
                    quality: 0.9,
                    multiplier: 15,
                    left: frontCord.l,
                    top: frontCord.t,
                    width: frontCord.w,
                    height: frontCord.h
                });
                
                var blob = img.replace(/^data:image\/(png|jpeg);base64,/, "");
                front_part = b64toBlob(blob, 'image/jpeg');
                printData.append('front_m', front_part, 'front_m.jpeg');
                canvas.overlayImage.visible = true;
                canvas.renderAll();  
            } catch (e) {
                bugsnagClient.notify(new Error(e));
                console.log(e);
            }

            showProgress(sizes.length*2);
            console.log("front");
            sendParts(true);
        }, interval);
    });
}

//get left leg of leggings print ready
function getLeftLegPrintReady(sizes) {
    canvas.clear();
    canvas.loadFromJSON(JSON.parse(front), function() {
        toggleVisibility('mask');
        $.each(sizes, function(index, size) {
            setTimeout(function () {  
                var plOverlay = printLeftOverlay[size];
                console.log('left '+size);
                fabric.Image.fromURL(plOverlay, function(overlayImg) {
                    overlayImg.scaleToHeight(canvas.getHeight());
                    overlayImg.set({
                        'id': 'overlay',
                        top: center.top,
                        left: center.left,
                        originX: 'center',
                        originY: 'center',
                        crossOrigin: 'anonymous'
                    });
                    canvas.setOverlayImage(overlayImg, canvas.renderAll.bind(canvas));

                    try {  
                        var img = canvas.toDataURL({
                            format: 'jpeg',
                            quality: 0.9,
                            multiplier: 10.0,
                            left: parseFloat((canvas.width - (canvas.overlayImage.width*canvas.overlayImage.scaleX))/2),
                            top: parseFloat((canvas.height - (canvas.overlayImage.height*canvas.overlayImage.scaleY))/2),
                            width: parseFloat(canvas.overlayImage.width*canvas.overlayImage.scaleX),
                            height: parseFloat(canvas.overlayImage.height*canvas.overlayImage.scaleY)
                        });  

                        var blob = img.replace(/^data:image\/(png|jpeg);base64,/, "");
                        left_leg = b64toBlob(blob, 'image/jpeg');
                        printData.append('left_'+ size, left_leg, 'left_'+ size +'.jpeg');
                    } catch (e) {
                        bugsnagClient.notify(new Error(e));
                        console.log(e);
                    } 

                    if((index+1) == sizes.length) {
                        console.log("last left");
                        setTimeout(function() { getRightLegPrintReady(sizes); }, interval);
                    }
                });
                showProgress(index);
            }, index * interval);
        });
    });
}

//get right leg of leggings
function getRightLegPrintReady(sizes) {
    $.each(sizes, function(index, size) {
        setTimeout(function () {  
            var prOverlay = printRightOverlay[size];
            console.log('right '+size);
            fabric.Image.fromURL(prOverlay, function(overlayImg) {
                overlayImg.scaleToHeight(canvas.getHeight());
                overlayImg.set({
                    'id': 'overlay',
                    top: center.top,
                    left: center.left,
                    originX: 'center',
                    originY: 'center',
                    crossOrigin: 'anonymous'
                });
                canvas.setOverlayImage(overlayImg, canvas.renderAll.bind(canvas)); 

                try {               
                    var img = canvas.toDataURL({
                        format: 'jpeg',
                        quality: 0.9,
                        multiplier: 10.0,
                        left: parseFloat((canvas.width - (canvas.overlayImage.width*canvas.overlayImage.scaleX))/2),
                        top: parseFloat((canvas.height - (canvas.overlayImage.height*canvas.overlayImage.scaleY))/2),
                        width: parseFloat(canvas.overlayImage.width*canvas.overlayImage.scaleX),
                        height: parseFloat(canvas.overlayImage.height*canvas.overlayImage.scaleY)
                    });  

                    var blob = img.replace(/^data:image\/(png|jpeg);base64,/, "");
                    right_leg = b64toBlob(blob, 'image/jpeg');
                    printData.append('right_'+ size, right_leg, 'right_'+ size +'.jpeg');
                } catch (e) {
                    bugsnagClient.notify(new Error(e));
                    console.log(e);
                } 

                if((index+1) == sizes.length) {
                    console.log("last right");
                    setTimeout(function() { sendParts(sizes); }, interval);
                }
            });
            showProgress(sizes.length*2);
        }, index * interval);
    });    
}

//get leggings print ready
function getLeggingsPrintReady(sizes) {
    var parts = {};
    var len = 0;
    var i = 0;
    
    //make simple array
    $.each(sizes, function(index, size) { 
        var bandOverlay = printBandOverlay[size];
        if(!$.isArray(bandOverlay)) { 
            parts[size] = bandOverlay;
        } else { 
            $.each(bandOverlay, function(i, v) {
                parts[size+'_'+i] = v;
            });
        }
    });
    canvas.clear();    
    //get print ready images
    canvas.setBackgroundImage($('#sleeve-pattern-img').val(), function(){
        $.each(parts, function(index, part) {
            setTimeout(function () {  
                console.log('band_'+ index);
                fabric.Image.fromURL(part, function(overlayImg) {
                    if(overlayImg.width > overlayImg.height) {
                        overlayImg.scaleToWidth(canvas.getWidth());
                    } else {
                        overlayImg.scaleToHeight(canvas.getHeight());
                    }
                    overlayImg.set({
                        'id': 'overlay',
                        top: center.top,
                        left: center.left,
                        originX: 'center',
                        originY: 'center',
                        crossOrigin: 'anonymous'
                    });
                    canvas.setOverlayImage(overlayImg, canvas.renderAll.bind(canvas));

                    try { 
                        //generate print ready for back
                        var img = canvas.toDataURL({
                            format: 'jpeg',
                            quality: 0.9,
                            multiplier: 10.0,
                            left: parseFloat((canvas.width - (overlayImg.width*overlayImg.scaleX))/2),
                            top: parseFloat((canvas.height - (overlayImg.height*overlayImg.scaleY))/2),
                            width: parseFloat(overlayImg.width*overlayImg.scaleX),
                            height: parseFloat(overlayImg.height*overlayImg.scaleY)
                        });  

                        var blob = img.replace(/^data:image\/(png|jpeg);base64,/, "");
                        band_part = b64toBlob(blob, 'image/jpeg');
                        printData.append('band_'+ index, band_part, 'band_'+ index +'.jpeg');     
                    } catch (e) {
                        bugsnagClient.notify(new Error(e));
                        console.log(e);
                    } 

                    len += 1;
                    if(len == Object.keys(parts).length) {
                        console.log("last band");
                        setTimeout(function() { getLeftLegPrintReady(sizes); }, interval);
                    }
                });
            }, (interval*i));
            i++;
        });
    }, {
        backgroundImageStretch: true,
        id: 'bg-image',
        scaleY: 0.333333,
        scaleX: 0.333333,
        crossOrigin: 'anonymous'
    });
}

//for summer products
function getProductPrintReady(l, t, w, h) { 
    canvas.overlayImage.visible = false;
    canvas.renderAll();
    console.log("removing overlay");
    setTimeout(function() {
        try {            
            var img = canvas.toDataURL({
                format: 'jpeg',
                quality: 0.9,
                multiplier: 16.5,
                left: l,
                top: t,
                width: w,
                height: h
            });        

            var blob = img.replace(/^data:image\/(png|jpeg);base64,/, "");
            front_part = b64toBlob(blob, 'image/jpeg');
            printData.append('front_m', front_part, 'front_m.jpeg');
            
            canvas.overlayImage.visible = true;
            console.log("applying overlay");
            canvas.renderAll();      
        } catch (e) {
            bugsnagClient.notify(new Error(e));
            console.log(e);
        } 
        sendParts();
    }, 2000);
}

$(document).ready(function() {    
    $.unblockUI();
});